<template>

<div v-cloak>
  <table class="table table--striped table--word-break table--stackable milli" v-if="forms.length">
    <thead>
    <tr>
      <th>ID</th>
      <th>{{ $_('instapage_id') }}</th>
      <th>{{ $_('name') }}</th>
      <th>{{ $_('campaign') }}</th>
      <th>{{ $_('send') }}</th>
      <th>{{ $_('to') }}</th>
      <th>{{ $_('actions') }}</th>
    </tr>
    </thead>
    <tbody>
      <tr v-for="item in forms" v-bind:key="item.instapage_id" valign="top">
        <td title="ID">{{ item.id }}</td>
        <td :data-title="$_('instapage_id')">{{ item.instapage_id }}</td>
        <td :data-title="$_('name')" v-bind:title="item.page_name"><div class="truncate" style="width: 150px;">{{ item.page_name }}</div></td>
        <td :data-title="$_('campaign')" v-bind:title="getCampaignName(item.campaign_id)"><div class="truncate" style="width: 100px;">{{ getCampaignName(item.campaign_id) }}</div></td>
        <td :data-title="$_('send')"><i class="fa" v-bind:class="{ 'fa-check ': item.send, 'fa-times': !item.send }"></i></td>
        <td :data-title="$_('to')">
          <div class="truncate" v-bind:title="item.to" style="width: 150px;">{{ item.to }}</div>
          <div class="truncate" v-bind:title="item.cc" style="width: 150px;">{{ item.cc }}</div>
          <div class="truncate" v-bind:title="item.bcc" style="width: 150px;">{{ item.bcc }}</div>
        </td>
        <td :data-title="$_('actions')">
          <div class="button-group flush--bottom">
            <button class="button button--small button--light" @click="edit(item)">{{ $_('edit') }}</button>
            <button class="button button--small button--light" @click="remove(item)">{{ $_('delete') }}</button>
          </div>
        </td>
      </tr>
    </tbody>
  </table>

  <p v-if="!forms.length">{{ $_('no_instapage') }}</p>

  <button type="button" class="button button--primary" v-on:click="enableNew" v-if="!showNew">{{ $_('add_new') }}</button>

  <form class="push--top" v-if="showNew" v-on:submit.prevent="onSubmit('form')" data-vv-scope="form">
    <h2>{{ (form.id) ? `${$_('edit_form')} ${form.id}` : $_('add_new_instapage') }}</h2>
    <div class="form grid">
      <div class="grid__item one-third portable--one-whole">
        <div class="form__line">
          <div class="form__field">
            <label for="instapage_id">{{ $_('instapage_id') }}:</label>
            <input type="number" min="0" v-validate="'numeric'" name="instapage_id" id="instapage_id" v-model.number="form.instapage_id" class="field field--text" :class="{ 'parsley-error': errors.has('form.instapage_id') }">
            <span v-show="errors.has('form.instapage_id')" class="parsley-errors-list ">{{ errors.first('form.instapage_id') }}</span>
          </div>
        </div>
        <div class="form__line">
          <div class="form__field">
            <label for="page_name">{{ $_('landing_page_name') }}:</label>
            <input type="text" min="0" v-validate="'required'" name="page_name" id="page_name" v-model.number="form.page_name" class="field field--text" :class="{ 'parsley-error': errors.has('form.page_name') }">
            <span v-show="errors.has('form.page_name')" class="parsley-errors-list ">{{ errors.first('form.page_name') }}</span>
          </div>
        </div>
        <div class="form__line">
          <div class="form__field">
            <label for="campaign_id">{{ $_('campaign') }}:</label>
            <select name="campaign_id" id="campaign_id" v-model.number="form.campaign_id" class="field field--select">
              <option value="0">{{ $_('no_campaign') }}</option>
              <option v-for="c in campaigns" v-bind:key="c.id" v-bind:value="c.id">{{ c.name }}</option>
            </select>
          </div>
        </div>
        <div class="form__line">
          <div class="form__field">
            <label for="send"><input type="checkbox" id="send" name="send" v-model="form.send"> {{ $_('send_email_notifications') }}</label>
          </div>
        </div>
      </div><!--
      --><div class="grid__item one-third portable--one-whole" v-if="form.send">
        <div class="form__line">
          <div class="form__field">
            <label for="to">{{ $_('to') }}: ({{ $_('comma_separated') }})</label>
            <input type="text" name="to" id="to" v-model="form.to" v-validate="'commaSeparated:email'" class="field field--text" :class="{ 'parsley-error': errors.has('form.to') }">
            <span v-show="errors.has('form.to')" class="parsley-errors-list ">{{ errors.first('form.to') }}</span>
          </div>
        </div>
        <div class="form__line">
          <div class="form__field">
            <label for="cc">{{ $_('cc') }}: ({{ $_('comma_separated') }})</label>
            <input type="text" name="cc" id="cc" v-model="form.cc" v-validate="'commaSeparated:email'" class="field field--text" :class="{ 'parsley-error': errors.has('form.cc') }">
            <span v-show="errors.has('form.cc')" class="parsley-errors-list ">{{ errors.first('form.cc') }}</span>
          </div>
        </div>
        <div class="form__line">
          <div class="form__field">
            <label for="bcc">{{ $_('bcc') }}: ({{ $_('comma_separated') }})</label>
            <input type="text" name="bcc" id="bcc" v-model="form.bcc" v-validate="'commaSeparated:email'" class="field field--text" :class="{ 'parsley-error': errors.has('form.bcc') }">
            <span v-show="errors.has('form.bcc')" class="parsley-errors-list ">{{ errors.first('form.bcc') }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="form__line flush--bottom">
      <button type="submit" class="button button--primary">{{ $_('save') }}</button>
      <button type="button" class="button button--default" @click="disableNew">{{ $_('cancel') }}</button>
    </div>
  </form>
  <div class="form__line push--top flush--bottom" v-if="error">
    <div class="form__field">
      <div class="parsley-error">{{ error }}</div>
    </div>
  </div>
</div>

</template>

<script>

var urlParser = document.createElement('a');
urlParser.href = location.href;

export default {
  name: 'forms',
  data () {
    return {
      forms: [],
      error: null,
      campaigns: null,
      client: {
        id: parseInt(urlParser.pathname.split('/')[2], 10)
      },
      showNew: false,
      form: {
        instapage_id: null,
        page_name: '',
        campaign_id: 0,
        send: false,
        to: '',
        cc: '',
        bcc: ''
      }
    }
  },
  mounted () {
    this.getForms();
    this.getCampaigns();
  },
  methods: {
    getForms: function() {
      var self = this;
      this.$http.get("/api/v1/" + this.client.id + "/forms").then(
        function(response) {
          self.forms = response.data.forms;
          self.client = response.data.client;
        },
        function(error) {
          console.error(error);
        }
      )
    },
    getCampaigns: function() {
      var self = this;
      this.$http.get("/api/v1/" + this.client.id + "/campaigns").then(
        function(response) {
          self.campaigns = response.data.campaigns;
          self.client = response.data.client;
        },
        function(error) {
          console.error(error);
        }
      )
    },
    enableNew: function() {
      this.showNew = true;
    },
    disableNew: function() {
      this.showNew = false;
      this.clearNew();
    },
    getCampaignName: function(campaign_id) {
      if (!this.campaigns) {
        return '';
      }
      var campaign = this.campaigns.filter(function(c) { return c.id == campaign_id; });
      return (campaign[0] && campaign[0].name) ? campaign[0].name : '';
    },
    clearNew: function() {
      this.form = {
        instapage_id: null,
        page_name: '',
        campaign_id: 0,
        send: false,
        to: '',
        cc: '',
        bcc: ''
      };
      this.error = null;
      this.$validator.pause();
      this.$nextTick(() => {
        this.$validator.reset();
        this.$validator.resume();
      });
    },
    onSubmit: function(scope) {
      var self = this;
      self.$validator.validateAll(scope).then(function(result) {
        if (!result) {
          return false;
        }
        var data = {
          id: self.form.id ? self.form.id : null,
          instapage_id: self.form.instapage_id,
          page_name: self.form.page_name,
          campaign_id: self.form.campaign_id,
          send: self.form.send ? 1 : 0,
          to: self.form.to,
          cc: self.form.cc,
          bcc: self.form.bcc,
        };
        if (data.id) {
          self.update(data)
        } else {
          self.post(data);
        }
      });
    },
    post: function(data) {
      var self = this;
      self.$http.post('/api/v1/' + this.client.id + '/forms', data).then(
        function(response) {
          if (response.data.status) {
            self.getForms();
            self.clearNew();
            self.disableNew();
          }
        },
        function(error) {
          console.error(error);
          self.error = error.response.data;
        }
      );
    },
    update: function(data) {
      var self = this;
      self.$http.put('/api/v1/' + this.client.id + '/forms/' + data.id, data).then(
        function(response) {
          if (response.data.status) {
            self.getForms();
            self.clearNew();
            self.disableNew();
          }
        },
        function(error) {
          console.error(error);
          self.error = error.response.data;
        }
      );
    },
    edit: function(page) {
      this.form = JSON.parse(JSON.stringify(page));
      this.error = null;
      this.enableNew();
    },
    remove: function(page) {
      if (!confirm(this.$_('instapage_delete_confirmation'))) { return false; }
      var self = this;
      self.$http.delete('/api/v1/' + this.client.id + '/forms/' + page.id).then(
        function(response) {
          if (response.data.status) {
            self.getForms();
          }
        },
        function(error) {
          console.error(error);
          self.error = error.response.data;
        }
      )
    }
  }
}

</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/Forms.vue